import {
  Indicators,
  MonthlyValues,
  PatchUsina,
  PostUsina,
  Support,
  Usina,
} from "./types";

export function getDifferentIndicatorsData(
  currentIndicators?: Indicators,
  newIndicators?: Indicators,
): Indicators | undefined {
  if (!currentIndicators || !newIndicators) {
    return undefined;
  }
  const differentIndicators: Indicators = {};

  const kwPeak = compareSingleNumberValues(
    currentIndicators.kwPeak,
    newIndicators.kwPeak,
  );
  if (kwPeak) {
    differentIndicators.kwPeak = kwPeak;
  }
  const totalPower = compareSingleNumberValues(
    currentIndicators.totalPower,
    newIndicators.totalPower,
  );
  if (totalPower) {
    differentIndicators.totalPower = totalPower;
  }
  const opticalLossesPercentage = compareSingleNumberValues(
    currentIndicators.opticalLossesPercentage,
    newIndicators.opticalLossesPercentage,
  );
  if (opticalLossesPercentage) {
    differentIndicators.opticalLossesPercentage = opticalLossesPercentage;
  }
  const conversionLossesPercentage = compareSingleNumberValues(
    currentIndicators.conversionLossesPercentage,
    newIndicators.conversionLossesPercentage,
  );
  if (conversionLossesPercentage) {
    differentIndicators.conversionLossesPercentage = conversionLossesPercentage;
  }
  const inverterLossesPercentage = compareSingleNumberValues(
    currentIndicators.inverterLossesPercentage,
    newIndicators.inverterLossesPercentage,
  );
  if (inverterLossesPercentage) {
    differentIndicators.inverterLossesPercentage = inverterLossesPercentage;
  }
  const transformerLossesPercentage = compareSingleNumberValues(
    currentIndicators.transformerLossesPercentage,
    newIndicators.transformerLossesPercentage,
  );
  if (transformerLossesPercentage) {
    differentIndicators.transformerLossesPercentage =
      transformerLossesPercentage;
  }
  const modulesArea = compareSingleNumberValues(
    currentIndicators.modulesArea,
    newIndicators.modulesArea,
  );
  if (modulesArea) {
    differentIndicators.modulesArea = modulesArea;
  }
  const variance = compareSingleNumberValues(
    currentIndicators.variance,
    newIndicators.variance,
  );
  if (variance) {
    differentIndicators.variance = variance;
  }
  const efficiency = compareSingleNumberValues(
    currentIndicators.efficiency,
    newIndicators.efficiency,
  );
  if (efficiency) {
    differentIndicators.efficiency = efficiency;
  }
  const irradiance = getDifferentMonthlyValues(
    currentIndicators.irradiance,
    newIndicators.irradiance,
  );
  if (irradiance) {
    differentIndicators.irradiance = irradiance;
  }
  const globInc = getDifferentMonthlyValues(
    currentIndicators.globInc,
    newIndicators.globInc,
  );
  if (globInc) {
    differentIndicators.globInc = globInc;
  }
  const pr = getDifferentMonthlyValues(currentIndicators.pr, newIndicators.pr);
  if (pr) {
    differentIndicators.pr = pr;
  }
  const predictedEnergy = getDifferentMonthlyValues(
    currentIndicators.predictedEnergy,
    newIndicators.predictedEnergy,
  );
  if (predictedEnergy) {
    differentIndicators.predictedEnergy = predictedEnergy;
  }
  const megaWattValue = compareSingleNumberValues(
    currentIndicators.megaWattValue,
    newIndicators.megaWattValue,
  );
  if (megaWattValue) {
    differentIndicators.megaWattValue = megaWattValue;
  }
  const pvsystExpectedOpticalLoss = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedOpticalLoss,
    newIndicators.pvSystExpectedOpticalLoss,
  );
  if (pvsystExpectedOpticalLoss) {
    differentIndicators.pvSystExpectedOpticalLoss = pvsystExpectedOpticalLoss;
  }
  const pvsystExpectedConversionLoss = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedConversionLoss,
    newIndicators.pvSystExpectedConversionLoss,
  );
  if (pvsystExpectedConversionLoss) {
    differentIndicators.pvSystExpectedConversionLoss =
      pvsystExpectedConversionLoss;
  }
  const pvsystExpectedInverterLoss = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedInverterLoss,
    newIndicators.pvSystExpectedInverterLoss,
  );
  if (pvsystExpectedInverterLoss) {
    differentIndicators.pvSystExpectedInverterLoss = pvsystExpectedInverterLoss;
  }
  const pvsystExpectedTransformerLoss = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedTransformerLoss,
    newIndicators.pvSystExpectedTransformerLoss,
  );
  if (pvsystExpectedTransformerLoss) {
    differentIndicators.pvSystExpectedTransformerLoss =
      pvsystExpectedTransformerLoss;
  }
  const pvsystExpectedSystem = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedSystem,
    newIndicators.pvSystExpectedSystem,
  );
  if (pvsystExpectedSystem) {
    differentIndicators.pvSystExpectedSystem = pvsystExpectedSystem;
  }
  const pvsystExpectedContractual = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedContractual,
    newIndicators.pvSystExpectedContractual,
  );
  if (pvsystExpectedContractual) {
    differentIndicators.pvSystExpectedContractual = pvsystExpectedContractual;
  }
  const pvsystExpectedInverter = getDifferentMonthlyValues(
    currentIndicators.pvSystExpectedInverter,
    newIndicators.pvSystExpectedInverter,
  );
  if (pvsystExpectedInverter) {
    differentIndicators.pvSystExpectedInverter = pvsystExpectedInverter;
  }
  if (Object.keys(differentIndicators).length > 0) {
    return differentIndicators;
  }
  return undefined;
}
export function getDifferentDetailsData(
  currentUsina: Usina | PostUsina | null,
  newUsina: Usina | PostUsina | null,
): PatchUsina | undefined {
  if (!newUsina) {
    return undefined;
  }
  const patchUsina: PatchUsina = {};
  const name = compareSingleStringValues(currentUsina?.name, newUsina.name);
  if (name) {
    patchUsina.name = name;
  }

  const support = getDifferentSupport(currentUsina?.support, newUsina.support);
  if (support) {
    patchUsina.support = support;
  }
  const clusterId = compareSingleStringValues(
    currentUsina?.clusterId,
    newUsina.clusterId,
  );
  if (clusterId) {
    patchUsina.clusterId = clusterId;
  }
  if (Object.keys(patchUsina).length > 0) {
    return patchUsina;
  }
  return undefined;
}
export function deepEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) {
    return true;
  }

  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!obj2.hasOwnProperty(key)) {
      return false;
    }

    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
export function getDifferentSupport(
  currentSupport: Support | undefined,
  newSupport: Support | undefined,
): Support | undefined {
  if (!currentSupport || !newSupport) {
    if (newSupport) {
      return newSupport;
    }
    return undefined;
  }
  const differentSupport: Support = {};
  const concessionaire = {
    contactEmail: compareSingleStringValues(
      currentSupport.concessionaire?.contactEmail,
      newSupport.concessionaire?.contactEmail,
    ),
    contactPhone: compareSingleStringValues(
      currentSupport.concessionaire?.contactPhone,
      newSupport.concessionaire?.contactPhone,
    ),
  };
  if (concessionaire.contactEmail || concessionaire.contactPhone) {
    differentSupport.concessionaire = concessionaire;
  }
  const internetProviders = newSupport.internetProviders?.map(
    (provider, index) => ({
      contactEmail: compareSingleStringValues(
        currentSupport.internetProviders?.[index]?.contactEmail,
        provider.contactEmail,
      ),
      contactPhone: compareSingleStringValues(
        currentSupport.internetProviders?.[index]?.contactPhone,
        provider.contactPhone,
      ),
    }),
  );
  if (
    internetProviders?.find(
      (provider) => provider.contactEmail || provider.contactPhone,
    )
  ) {
    differentSupport.internetProviders = internetProviders;
  }
  if (Object.keys(differentSupport).length > 0) {
    return differentSupport;
  }
  return undefined;
}
export function getDifferentMonthlyValues(
  currentValues?: MonthlyValues | null,
  newValues?: MonthlyValues | null,
) {
  if (!currentValues && !newValues) {
    return undefined;
  }
  console.log("cheguei", currentValues, newValues);
  const differentValues: MonthlyValues = {};
  const jan = compareSingleNumberValues(currentValues?.jan, newValues?.jan);
  if (jan) {
    differentValues.jan = jan;
  }
  const feb = compareSingleNumberValues(currentValues?.feb, newValues?.feb);
  if (feb) {
    differentValues.feb = feb;
  }
  const mar = compareSingleNumberValues(currentValues?.mar, newValues?.mar);
  if (mar) {
    differentValues.mar = mar;
  }
  const apr = compareSingleNumberValues(currentValues?.apr, newValues?.apr);
  if (apr) {
    differentValues.apr = apr;
  }
  const may = compareSingleNumberValues(currentValues?.may, newValues?.may);
  if (may) {
    differentValues.may = may;
  }
  const jun = compareSingleNumberValues(currentValues?.jun, newValues?.jun);
  if (jun) {
    differentValues.jun = jun;
  }
  const jul = compareSingleNumberValues(currentValues?.jul, newValues?.jul);
  if (jul) {
    differentValues.jul = jul;
  }
  const aug = compareSingleNumberValues(currentValues?.aug, newValues?.aug);
  if (aug) {
    differentValues.aug = aug;
  }
  const sep = compareSingleNumberValues(currentValues?.sep, newValues?.sep);
  if (sep) {
    differentValues.sep = sep;
  }
  const oct = compareSingleNumberValues(currentValues?.oct, newValues?.oct);
  if (oct) {
    differentValues.oct = oct;
  }
  const nov = compareSingleNumberValues(currentValues?.nov, newValues?.nov);
  if (nov) {
    differentValues.nov = nov;
  }
  const dec = compareSingleNumberValues(currentValues?.dec, newValues?.dec);
  if (dec) {
    differentValues.dec = dec;
  }

  if (Object.keys(differentValues).length > 0) {
    return differentValues;
  }
  return undefined;
}
function compareSingleNumberValues(
  currentValue: number | null | undefined,
  newValue: number | null | undefined,
) {
  if (
    newValue &&
    (currentValue?.toString() !== newValue.toString() || !currentValue)
  ) {
    return newValue;
  }
}
function compareSingleStringValues(
  currentValue: string | null | undefined,
  newValue: string | null | undefined,
) {
  if (
    newValue &&
    (currentValue?.toString() !== newValue.toString() || !currentValue)
  ) {
    return newValue;
  }
}
